// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7cc4ba62","703":"3685a721"}[chunkId] + ".chunk.js";
};